/**
 * @module Client
 *
 * @description HTTP API Client
 */
/**
 * Default configuration
 */
export const defaults = {
    tls: true,
    api_key: "",
    baseUrl: "api.ideal-postcodes.co.uk",
    version: "v1",
    strictAuthorisation: false,
    timeout: 10000,
    header: {
        Accept: "application/json",
        "Content-Type": "application/json",
    },
    tags: [],
    agent: {},
};
/**
 * Client Class
 */
export class Client {
    constructor(config) {
        this.config = { ...defaults, ...config };
        this.config.header = {
            ...defaults.header,
            ...(config.header && config.header),
        };
    }
    /**
     * Return base URL for API requests
     */
    url() {
        const { baseUrl, version } = this.config;
        return `${this.protocol()}://${baseUrl}/${version}`;
    }
    protocol() {
        return this.config.tls ? "https" : "http";
    }
}
